import { render, staticRenderFns } from "./detail-calendar.vue?vue&type=template&id=1f346542"
import script from "./detail-calendar.vue?vue&type=script&lang=js"
export * from "./detail-calendar.vue?vue&type=script&lang=js"
import style0 from "./detail-calendar.vue?vue&type=style&index=0&id=1f346542&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports